package fr.manyverse.app.presentation.error

import kotlinx.coroutines.channels.BufferOverflow
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

/**
 * Signale à l'utilisateur l'échec d'une action qu'aucun état d'écran n'affiche : actions de partie
 * lancées sans attendre leur résultat (timer, combat, tableau blanc, digicode…).
 *
 * Les échecs sont affichés en snackbar par `UserErrorSnackbarHost`, avec le message de
 * [toUserMessage]. Le gestionnaire est prévenu par ailleurs : `mapToDomainException` remonte
 * déjà à Sentry les erreurs anormales.
 *
 * Un échec signalé sans écran pour l'afficher est perdu : il n'a plus de sens une fois l'écran
 * quitté.
 */
class UserErrorNotifier {

    private val _errors = MutableSharedFlow<Throwable>(
        extraBufferCapacity = 1,
        onBufferOverflow = BufferOverflow.DROP_OLDEST
    )
    val errors: SharedFlow<Throwable> = _errors.asSharedFlow()

    fun notify(error: Throwable) {
        _errors.tryEmit(error)
    }
}
